import { Link } from "react-router-dom";
import { languageHelper } from "../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

console.log(languageHelper(defaultLang, "Daily Sale Report"));
function Reporting() {
  const reportingData = [
    {
      name: languageHelper(defaultLang, "Daily Sale Report"),
      path: "dailySaleReport",
    },
    {
      name: languageHelper(defaultLang, "Detailed Sale Report"),
      path: "detailedSaleReport",
    },
    {
      name: languageHelper(defaultLang, "Detailed Shift Report"),
      path: "detailedShiftReport",
    },
  ];

  const businessReport = [
    {
      name: languageHelper(defaultLang, "Vat Report"),
      path: "vatReport",
    },
    {
      name: languageHelper(defaultLang, "Multiple Vat Report"),
      path: "multipleVatReport",
    },
    {
      name: languageHelper(defaultLang, "Overall report"),
      path: "overallReport",
    },
    {
      name: languageHelper(defaultLang, "Daily Summary Report"),
      path: "dailySummaryReport",
    },
    {
      name: languageHelper(defaultLang, "Profit Loss Report"),
      path: "profitLossReport",
    },
    {
      name: languageHelper(defaultLang, "Kitchen Performance Report"),
      path: "kitchenPerformanceReport",
    },
  ];

  const payableReport = [
    {
      name: languageHelper(defaultLang, "Expense Report"),
      path: "expensesReport",
    },
    {
      name: languageHelper(defaultLang, "Return Report"),
      path: "returnReport",
    },
    {
      name: languageHelper(defaultLang, "Loyalty Points Report"),
      path: "loyaltyPointReport",
    },
    {
      name: languageHelper(defaultLang, "Purchase Report"),
      path: "purchaseReport",
    },
    {
      name: languageHelper(defaultLang, "Detailed Purchase Report"),
      path: "detailPurchaseReport",
    },
    {
      name: languageHelper(defaultLang, "Customer Due Report"),
      path: "customerDueReport",
    },
    {
      name: languageHelper(defaultLang, "Supplier Ledger"),
      path: "supplierLedgerReport",
    },

    {
      name: languageHelper(defaultLang, "Customer Ledger"),
      path: "customerLedger",
    },

    {
      name: languageHelper(defaultLang, "Supplier Due Report"),
      path: "supplierDueReport",
    },
  ];

  const activityReport = [
    {
      name: languageHelper(defaultLang, "Register Report"),
      path: "registerReport",
    },
    {
      name: languageHelper(defaultLang, "Rider Report"),
      path: "riderReport",
    },
    {
      name: languageHelper(defaultLang, "Vendor report"),
      path: "vendorReport",
    },
    {
      name: languageHelper(defaultLang, "Food Sale Report"),
      path: "foodSalesReport",
    },
    {
      name: languageHelper(defaultLang, "Waste Report"),
      path: "wasteReport",
    },
    {
      name: languageHelper(defaultLang, "Attendance Report"),
      path: "attendanceReport",
    },
    {
      name: languageHelper(defaultLang, "Low Inventory Report"),
      path: "lowInventoryReport",
    },

    {
      name: languageHelper(defaultLang, "Consumption Report"),
      path: "consumptionReport",
    },

    {
      name: languageHelper(defaultLang, "Inventory Report"),
      path: "inventoryReport",
    },
  ];

  return (
    <main className="my-16">
      <div>
        <h1 className="text-d-bg-text text-2xl font-medium pt-4">
          {languageHelper(defaultLang, "Reporting")}
        </h1>
      </div>
      <div className="relative my-8 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex flex-col lg:flex-row gap-y-2 w-full py-3">
          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper(defaultLang, "Sales")}
            </h1>
            {reportingData &&
              reportingData.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper(defaultLang, "Business Overview")}
            </h1>
            {businessReport &&
              businessReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper(defaultLang, "Payables and Receivables")}
            </h1>
            {payableReport &&
              payableReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>

          <div className="w-full lg:w-1/3">
            <h1 className=" text-d-bg-text text-lg">
              {languageHelper(defaultLang, "Activity")}
            </h1>
            {activityReport &&
              activityReport.map((data) => (
                <Link to={data.path} target="_blank">
                  <h1 className="text-sm text-blue-400 pt-2 hover:text-d-bg-text">
                    {data.name}
                  </h1>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </main>
  );
}
export default Reporting;
